module.exports = __webpack_public_path__ + "media/images/workplace/welcome_bg/1-6c33a72854c23024a3e7ed4db9e11193.jpg";